import { css } from 'styled-components';

import { styled } from '@notino/react-styleguide';

import { ICurrencyProps } from '@components/PriceLabel/components/Currency';

import { Line } from '../SelectedVariant/styled';

export const Wrapper = styled.div<{ leftPadding?: boolean }>`
  padding-bottom: 1rem;
  ${({ leftPadding }) => leftPadding && 'padding-left: 0.75rem;'}
`;

export const LabelRow = styled.div`
  display: flex;
  flex-flow: row;
  gap: 0.5rem;

  > span {
    display: flex;
    gap: 0.25rem;
  }
`;

export const PriceWrapper = styled.span`
  ${({ isSpaced, isPrefix }: ICurrencyProps) => {
    if (isSpaced)
      return isPrefix
        ? css`
            :after {
              content: ' ';
            }
          `
        : css`
            :before {
              content: ' ';
            }
          `;
  }}
`;

export const WrapperComponent = styled.div``;

export const LineSeparator = styled(Line)`
  margin-bottom: 0.75rem;
`;

export const DualPriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const PriceSplitter = styled.span`
  padding: 0 0.2rem;
`;
